import api from '@/lib/axios';

class FormDataService {
  // Get user's existing form data and answers
  async getUserData(userId) {
    try {
      const response = await api.get(`/get-user-answers/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error in getUserData:', error);
      
      // Check for specific error messages and re-throw with the exact message
      if (error.response?.data?.message) {
        const errorMessage = error.response.data.message;
        if (errorMessage === "No video found" || 
            errorMessage === "No transcription found" || 
            errorMessage === "Form not found") {
          // Re-throw the error with the specific message preserved
          const preservedError = new Error(errorMessage);
          preservedError.response = error.response;
          throw preservedError;
        }
      }
      
      throw error;
    }
  }

  // Save form step data with new API format
  async saveStepData(formId, userId, fieldsData) {
    try {
      const payload = {
        form_id: formId,
        user_id: userId,
        values: fieldsData.map(field => ({
          field_id: field.field_id,
          value: field.value || "",
          skip: field.skip || 0
        }))
      };

      const response = await api.post(`/update-user-answers`, payload);
      return response.data;
    } catch (error) {
      console.error('Error in saveStepData:', error);
      throw error;
    }
  }

  // Save file data specifically
  async saveFileData(formId, userId, fieldId, value, skip = 0) {
    try {
      const payload = {
        form_id: formId,
        user_id: userId,
        values: [{
          field_id: fieldId,
          value: value,
          skip: skip
        }]
      };

      const response = await api.post(`/update-user-answers`, payload);
      return response.data;
    } catch (error) {
      console.error('Error in saveFileData:', error);
      throw error;
    }
  }

  // Save skip status for fields
  async saveSkipStatus(formId, userId, fieldId, skip = 1) {
    try {
      const payload = {
        form_id: formId,
        user_id: userId,
        values: [{
          field_id: fieldId,
          value: "",
          skip: skip
        }]
      };

      const response = await api.post(`/update-user-answers`, payload);
      return response.data;
    } catch (error) {
      console.error('Error in saveSkipStatus:', error);
      throw error;
    }
  }

  // Get user's form submission status
  async getUserSubmissionStatus(userId) {
    try {
      const response = await api.get(`/v1/user-submission-status/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error in getUserSubmissionStatus:', error);
      throw error;
    }
  }

  // Submit final form
  async submitFinalForm(payload) {
    try {
      const response = await api.post(`/v1/submit-form`, payload);
      return response.data;
    } catch (error) {
      console.error('Error in submitFinalForm:', error);
      throw error;
    }
  }
}

export const formDataService = new FormDataService(); 